<div class="experience-container">
  <button class="back-button" (click)="goBack()">
    back
    <svg
      width="20"
      height="20"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      >
      <path
        d="M6.85355 3.14645C7.04882 3.34171 7.04882 3.65829 6.85355 3.85355L3.70711 7H12.5C12.7761 7 13 7.22386 13 7.5C13 7.77614 12.7761 8 12.5 8H3.70711L6.85355 11.1464C7.04882 11.3417 7.04882 11.6583 6.85355 11.8536C6.65829 12.0488 6.34171 12.0488 6.14645 11.8536L2.14645 7.85355C1.95118 7.65829 1.95118 7.34171 2.14645 7.14645L6.14645 3.14645C6.34171 2.95118 6.65829 2.95118 6.85355 3.14645Z"
        fill="currentColor"
        fill-rule="evenodd"
        clip-rule="evenodd"
      ></path>
    </svg>
  </button>
  <h4 class="text-gray__dark">How was your experience using this app?</h4>
  <div class="rating-container">
    <div class="rating-items">
      @for (star of stars; track star) {
        <div
          class="star"
          [class.active]="isStarActive(star)"
          [class.inactive]="!isStarActive(star)"
          (mouseenter)="handleMouseEnter(star)"
          (mouseleave)="handleMouseLeave()"
          (click)="selectRating(star)"
          >
          ★
        </div>
      }
    </div>
    <p class="rating-size">{{ selectedRating }}/5</p>
  </div>

  <div>
    <textarea
      name=""
      id=""
      placeholder="How can we improve?..."
      [(ngModel)]="feedback"
    ></textarea>
  </div>
  <button
    [disabled]="selectedRating === 0"
    class="btn w-100 text-white form-btn no-margin-l no-margin-r"
    [style.background-color]="
      checkoutSettings?.whiteLabelInfo
        ? checkoutSettings?.whiteLabelInfo?.brandColor
        : '#ed1c25'
    "
    (click)="submitReview()"
    >
    Submit
  </button>
  <div
    class="footer"
    style="margin-top: 2%; text-align: center; font-size: 12px"
    >
    Powered By:
    <!--  -->
    @if (checkoutSettings && checkoutSettings?.whiteLabelInfo) {
      @if (checkoutSettings && checkoutSettings?.whiteLabelInfo) {
        <img
          width="50"
          alt="logo"
          class="logo"
          [src]="checkoutSettings?.whiteLabelInfo?.logoUrl"
          />
      }
    } @else {
      <img width="50" src="../../../assets/rexpay/ga.png" />
    }
  </div>
</div>
